import {iotDevicesConstants} from '../constants/iotDevices.constants';

export function IotDevices(state = {}, action) {
  switch (action.type) {
    case iotDevicesConstants.IOT_DEVICES_LOAD_DATA_REQUEST:
      return {
        loading: true
      };
    case iotDevicesConstants.IOT_DEVICES_LOAD_DATA_SUCCESS:
      return {
        ...state,
        ...state.IOT_DEVICES,
        data: action.data
      };
    case iotDevicesConstants.IOT_DEVICES_LOAD_DATA_FAILURE:
      return {
        ...state,
        ...state.IOT_DEVICES,
        error: action.error
      };


    case iotDevicesConstants.IOT_DEVICES_LOAD_DETAIL_SUCCESS:
      return {
        ...state,
        ...state.IOT_DEVICES,
        detail: action.detail
      };
    case iotDevicesConstants.IOT_DEVICES_LOAD_DETAIL_FAILURE:
      return {
        error: action.error
      };

    case iotDevicesConstants.IOT_DEVICES_SET_DETAIL_ID:
      return {
        ...state,
        ...state.IOT_DEVICES,
        detailId: action.detailId
      };

    case iotDevicesConstants.IOT_DEVICES_SAVE_DATA_SUCCESS:
      return {
        ...state,
        ...state.IOT_DEVICES,
        isSubmitting: action.isSubmitting
      };

    case iotDevicesConstants.IOT_DEVICES_ADD_TO_SELECTED:
      let count = state.selected && state.selected.length;
      //state && state.selected && action.item ? state.selected.filter(item => item.id === action.item.id) : [];
      if (count === 0) {
        return {
          ...state,
          ...state.IotDevices,
          selected: state && state.selected ? [...state.selected, action.item] : [action.item]
        };
      } else {
        return {
          ...state,
          ...state.IotDevices,
          ...state.selected
        };
      }

    default:
      return state
  }
}